// Перестановка чипов в ряду (исполнители задачи, состав команды): чистая часть.
// Порядок чипов — порядок сохранения, а у задачи ещё и порядок полос цвета на баре.

/** Перед каким чипом встанет брошенный: указатель в левой половине чипа — перед ним, в правой — перед следующим (null — в конец). */
export function chipAnchor(ids: readonly string[], overId: string, pointerX: number, overRect: { left: number; width: number }): string | null {
  const i = ids.indexOf(overId);
  if (i < 0) return null;
  const before = pointerX < overRect.left + overRect.width / 2;
  return before ? overId : (ids[i + 1] ?? null);
}

/** Новый порядок после броска fromId перед anchorId (null — в конец); тот же массив, если ничего не меняется. */
export function dropChip(ids: readonly string[], fromId: string, anchorId: string | null): string[] {
  if (fromId === anchorId) return [...ids];
  const rest = ids.filter((id) => id !== fromId);
  const at = anchorId === null ? rest.length : rest.indexOf(anchorId);
  return [...rest.slice(0, at < 0 ? rest.length : at), fromId, ...rest.slice(at < 0 ? rest.length : at)];
}

/** Сдвиг чипа на шаг клавиатурой (Alt+←/→); у края остаётся на месте. */
export function moveChip(ids: readonly string[], id: string, delta: -1 | 1): string[] {
  const i = ids.indexOf(id);
  const j = i + delta;
  if (i < 0 || j < 0 || j >= ids.length) return [...ids];
  const out = [...ids];
  [out[i], out[j]] = [out[j]!, out[i]!];
  return out;
}
